import React from "react";
import InfoColumns from '../Stats/InfoColumns';
import {HscStatsData} from './models/hscstats';
import axios from "axios";
import { ApolloConsumer } from "@apollo/client";
import { GET_NEW_HSC_RATES, GET_PRIME_RATES, GET_STATS_BY_BUYER_STATE, GET_STATS_BY_STATUS_HSC, GET_STATS_BY_TYPE } from "../Graphql/Queries/HscStatsQuery";
import { mapToOldResponse } from "../ResponseConversion/GetOldResponse";
import { fetchData } from "../Service/graphQlService";
import { GET_HSC_RATE_HISTORIES, GET_RATES } from "../Graphql/Queries/getStatsDataQuery";
import HscStatsColumns from "../Stats/HscStatsColumns";

const cloneDeep = require('lodash.clonedeep');

export default class HscStats extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stats: new HscStatsData({}),
            totalClosedSum: null,
            totalClosedCount: null,
            isYtdClosing: true,
            fiveYear:'',
            tenyear:'',
            fiveYearChart:{},
            tenYearChart: {},
            oneMonthSOFR: '0%',
            oneYearSOFR: '0%',
            oneYearForTenYearUTR: '0%',
            oneYearForFiveYearSOFR: '0%',
            oneYearPrimeRate: '0%',
            hscRates: {
                us_treasury_1yr: "0%",
                us_treasury_3yr: "0%",
                us_treasury_5yr: "0%",
                us_treasury_7yr: "0%",
                us_treasury_10yr: "0%",

                sofr_swap_1mo: "0%",
                sofr_swap_1yr: "0%",
                sofr_swap_3yr: "0%",
                sofr_swap_5yr: "0%",

                sofr_rate: "0%",
                prime_rate: "0%",
                fed_funds_rate: "0%",

                current_us_treasury_1yr: "0%",
                current_us_treasury_3yr: "0%",
                current_us_treasury_5yr: "0%",
                current_us_treasury_7yr: "0%",
                current_us_treasury_10yr: "0%",
                current_sofr_swap_1yr: "0%",
                current_sofr_swap_3yr: "0%",
                current_sofr_swap_5yr: "0%",
                current_sofr_rate: "0%",
                current_prime_rate: "0%",
                current_fed_funds_rate: "0%"
                }

        };
    }

    getFedDate() {
        let that = this;
        axios
        .get("https://quote.cnbc.com/quote-html-webservice/restQuote/symbolType/symbol?symbols=US10Y&requestMethod=itv&noform=1&partnerId=2&fund=1&exthrs=1&output=json&events=1")
        .then(function (response) {
            that.setState({tenyear : (parseFloat(response.data.FormattedQuoteResult.FormattedQuote[0].last.replaceAll('%','')).toFixed(2)+'%')});
        });
        axios
        .get("https://quote.cnbc.com/quote-html-webservice/restQuote/symbolType/symbol?symbols=US5Y&requestMethod=itv&noform=1&partnerId=2&fund=1&exthrs=1&output=json&events=1")
        .then(function (response) {
            that.setState({fiveYear : (parseFloat(response.data.FormattedQuoteResult.FormattedQuote[0].last.replaceAll('%','')).toFixed(2)+'%')});
        });
        //Get 10Y 6 months data
        axios
        .get('https://webql-redesign.cnbcfm.com/graphql?operationName=getQuoteChartData&variables=%7B%22symbol%22%3A%22US10Y%22%2C%22timeRange%22%3A%226M%22%7D&extensions=%7B%22persistedQuery%22%3A%7B%22version%22%3A1%2C%22sha256Hash%22%3A%2261b6376df0a948ce77f977c69531a4a8ed6788c5ebcdd5edd29dd878ce879c8d%22%7D%7D')
        .then(function (response) {
            let chartDate = response.data.data.chartData.priceBars;
            that.setState({tenYearChart : (chartDate.map((d) => [d.tradeTime, d.close]))});
        });

        //Get 5Y 6 months data
        axios
        .get('https://webql-redesign.cnbcfm.com/graphql?operationName=getQuoteChartData&variables=%7B%22symbol%22%3A%22US5Y%22%2C%22timeRange%22%3A%226M%22%7D&extensions=%7B%22persistedQuery%22%3A%7B%22version%22%3A1%2C%22sha256Hash%22%3A%2261b6376df0a948ce77f977c69531a4a8ed6788c5ebcdd5edd29dd878ce879c8d%22%7D%7D')
        .then(function (response) {
            that.setState({fiveYearChart : (response.data.data.chartData.priceBars.map((d) => [d.tradeTime, d.close]))});
        });
        fetchData(GET_RATES)
        .then(function (result) {
            const response = result.data.getRates.data
            if(response){
                that.setState({
                    oneMonthSOFR : parseFloat( response.PreviousDay).toFixed(2)+'%',
                    oneYearSOFR : parseFloat( response.PreviousYear).toFixed(2)+'%',
                });
            }
        });

        fetchData(GET_HSC_RATE_HISTORIES)
        .then(function (result) {
            const response = result.data.getHSCRateHistories.data
            if(response){
                that.setState({
                    oneYearForTenYearUTR: response['10_YearTreasuryRate'],
                    oneYearForFiveYearSOFR:response['5_YearTreasuryRate'],
                    oneYearPrimeRate: response.USBankPrimeLoanRate
                });
            }
        });
    }

    fetch() {
        const token = localStorage.getItem('authToken');
        const ytd = new Date().getFullYear();
        const firstDayOfYtd = `${ytd}-01-01`;
        const firstDayPriorYtd = `${ytd - 1}-01-01`;
        const sinceDate = `${ytd - 2}-01-01`; // since 2 years ago

        // Promise.all([
        //     executeQuery({queryName: STATS_BY_STATUS_HSC, params: {}}),
        //     executeQuery({queryName: STATS_BY_TYPE, params: {}}),
        //     executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: firstDayOfYtd}}),
        //     executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: firstDayPriorYtd}}),
        //     executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: sinceDate}}),
        //     request(arc.path.api, {
        //         service: 'arcimedes',
        //         action: 'open.datasource.table.Data.getData',
        //         params: ['code', PRIME_RATES]                     
        //         }),
        // ]).then((res) => {
            if(this.client){
                Promise.all([
                // this.client.query({
                //     query: GET_STATS_BY_STATUS_HSC,  fetchPolicy: "no-cache",
                    
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STATS_BY_TYPE, fetchPolicy: "no-cache",
                    
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STATS_BY_BUYER_STATE, {date: `${ytd}`}, fetchPolicy: "no-cache",
                    
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STATS_BY_BUYER_STATE, variables:  {date: `${ytd - 1}` }, fetchPolicy: "no-cache",
                    
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_STATS_BY_BUYER_STATE, variables: {date: `${ytd - 2}`}, fetchPolicy: "no-cache",
                    
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // }),
                // this.client.query({
                //     query: GET_PRIME_RATES, variables: {pageOptions: { page: 1, pageSize: 50 }}, fetchPolicy: "no-cache",
                    
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`, // Bearer token added here
                //         },
                //     },
                // })


                fetchData( GET_STATS_BY_STATUS_HSC),
                fetchData( GET_STATS_BY_TYPE),
                fetchData( GET_STATS_BY_BUYER_STATE, {date: `${ytd}`}),
                fetchData( GET_STATS_BY_BUYER_STATE, {date: `${ytd - 1}` }),
                fetchData( GET_STATS_BY_BUYER_STATE,  {date: `${ytd - 2}`}),
                // fetchData( GET_PRIME_RATES,{pageOptions: { page: 1, pageSize: 50 }}),
                fetchData(GET_NEW_HSC_RATES)
            ]).then(res => {
                 const result = mapToOldResponse(res).responses;
                  // if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
            //     res[1] && res[1].success && Array.isArray(res[1].data) &&
            //     res[2] && res[2].success && Array.isArray(res[2].data) &&
            //     res[3] && res[3].success && Array.isArray(res[3].data) &&
            //     res[4] && res[4].success && Array.isArray(res[4].data) && 
            //     res[5] && res[5].success && Array.isArray(res[5].data)) {
                if (result && result[0] && result[0].success && Array.isArray(result[0].data) &&
                result[1] && result[1].success && Array.isArray(result[1].data) &&
                result[2] && result[2].success && Array.isArray(result[2].data) &&
                result[3] && result[3].success && Array.isArray(result[3].data) &&
                result[4] && result[4].success && Array.isArray(result[4].data) && 
                // result[5] && result[5].success && Array.isArray(result[5].data) &&
                result[5] && result[5].success && Array.isArray(result[5].data)) {
                    // const stats = new HscStatsData({
                    //     dataByStatus: res[0].data[0],
                    //     dataByType: res[1].data[0],
                    // });
                    // const isYtdClosing = !(res[0].data[0] && res[0].data[0].CLOSED_YTD_PROPERTIES && parseInt(res[0].data[0].CLOSED_YTD_PROPERTIES) < 1);
    
                    // const {listedChartData, soldChartData} = cloneDeep(this.state);
                const stats = new HscStatsData({
                    dataByStatus: result[0].data[0].STATSBYSTATUSHSC.DATA[0],
                    dataByType: result[1].data[0].STATSBYTYPE.DATA[0],
                });
                const isYtdClosing = !(result[0].data[0].STATSBYSTATUSHSC.DATA[0] && result[0].data[0].STATSBYSTATUSHSC.DATA[0].CLOSED_YTD_PROPERTIES && parseInt(result[0].data[0].STATSBYSTATUSHSC.DATA[0].CLOSED_YTD_PROPERTIES) < 1);

                const {listedChartData, soldChartData} = cloneDeep(this.state);
                // listedChartData[0].y = stats.activeStnlCount;
                // listedChartData[1].y = stats.activeMtCount;
                // soldChartData[0].y = stats.closedStnlCount;
                // soldChartData[1].y = stats.closedMtCount;
                // let sum = res[1].data[0].CLOSED_PRICE;
                // let count = res[1].data[0].CLOSED_COUNT;
                let sum = result[1].data[0].STATSBYTYPE.DATA[0].CLOSED_PRICE;
                let count = result[1].data[0].STATSBYTYPE.DATA[0].CLOSED_COUNT;
                sum = (sum / Math.pow(10, 9)).toString();
                sum = sum.slice(0, sum.indexOf('.') + 2);
                count = parseInt(count / 25) * 25;


                // let chartData = Stats.buildBuyerStateChartData(isYtdClosing ? res[2].data : res[3].data);
                // const buyerStateYtdChartData = chartData.chartOptionsData;
                // const buyerStateYtdTotal = chartData.total;
                // chartData = Stats.buildBuyerStateChartData(res[4].data);
                // const buyerStateChartData = chartData.chartOptionsData;
                // const buyerStateTotal = chartData.total;
                // {key: 'Transactions', value: stats.loanInProcessCount},
                // const primeRates = [
                //     {
                //         //key:'Prime Rate', value:res[5].data[0].THIS_WEEK
                //         key:'Prime Rate', value:result[5].data[0].GETPRIMERATESLIST[0].THIS_WEEK
                //     },
                // ]
                this.setState({
                    stats,
                    listedChartData,
                    soldChartData,
                    totalClosedSum: sum,
                    totalClosedCount: count,
                    isYtdClosing,
                    // primeRates,
                    hscRates: {
                        us_treasury_1yr: result[5].data[0].GETNEWHSCRATES.US_TREASURY_1YR,
                        us_treasury_3yr: result[5].data[0].GETNEWHSCRATES.US_TREASURY_3YR,
                        us_treasury_5yr: result[5].data[0].GETNEWHSCRATES.US_TREASURY_5YR,
                        us_treasury_7yr: result[5].data[0].GETNEWHSCRATES.US_TREASURY_7YR,
                        us_treasury_10yr: result[5].data[0].GETNEWHSCRATES.US_TREASURY_10YR,

                        sofr_swap_1yr: result[5].data[0].GETNEWHSCRATES.SOFR_SWAP_1YR,
                        sofr_swap_3yr: result[5].data[0].GETNEWHSCRATES.SOFR_SWAP_3YR,
                        sofr_swap_5yr: result[5].data[0].GETNEWHSCRATES.SOFR_SWAP_5YR,

                        sofr_rate: result[5].data[0].GETNEWHSCRATES.SOFR_RATE,
                        prime_rate: result[5].data[0].GETNEWHSCRATES.PRIME_RATE,
                        fed_funds_rate: result[5].data[0].GETNEWHSCRATES.FED_FUNDS_RATE,

                        current_us_treasury_1yr: result[5].data[0].GETNEWHSCRATES.CURRENT_US_TREASURY_1YR,
                        current_us_treasury_3yr: result[5].data[0].GETNEWHSCRATES.CURRENT_US_TREASURY_3YR,
                        current_us_treasury_5yr: result[5].data[0].GETNEWHSCRATES.CURRENT_US_TREASURY_5YR,
                        current_us_treasury_7yr: result[5].data[0].GETNEWHSCRATES.CURRENT_US_TREASURY_7YR,
                        current_us_treasury_10yr: result[5].data[0].GETNEWHSCRATES.CURRENT_US_TREASURY_10YR,

                        current_sofr_swap_1yr: result[5].data[0].GETNEWHSCRATES.CURRENT_SOFR_SWAP_1YR,
                        current_sofr_swap_3yr: result[5].data[0].GETNEWHSCRATES.CURRENT_SOFR_SWAP_3YR,
                        current_sofr_swap_5yr: result[5].data[0].GETNEWHSCRATES.CURRENT_SOFR_SWAP_5YR,

                        current_sofr_rate: result[5].data[0].GETNEWHSCRATES.CURRENT_SOFR_RATE,
                        current_prime_rate: result[5].data[0].GETNEWHSCRATES.CURRENT_PRIME_RATE,
                        current_fed_funds_rate: result[5].data[0].GETNEWHSCRATES.CURRENT_FED_FUNDS_RATE
                    }

                });
            }
        });
    }
    }

    componentDidMount() {
        this.fetch();
        // this.getFedDate();
    }

    render() {
        const {stats, isYtdClosing, hscRates} = this.state;
            const ytd = new Date().getFullYear();
        

        let usTreasury = [
            { label: '1 Yr', current: hscRates.current_us_treasury_1yr, prior: hscRates.us_treasury_1yr },
            { label: '3 Yr', current: hscRates.current_us_treasury_3yr, prior: hscRates.us_treasury_3yr },
            { label: '5 Yr', current: hscRates.current_us_treasury_5yr, prior: hscRates.us_treasury_5yr },
            { label: '7 Yr', current: hscRates.current_us_treasury_7yr, prior: hscRates.us_treasury_7yr },
            { label: '10 Yr', current: hscRates.current_us_treasury_10yr, prior: hscRates.us_treasury_10yr },
          ];
          
          let newOneMonthSOFR = [
            { label: '1 Yr', current: hscRates.current_sofr_swap_1yr, prior: hscRates.sofr_swap_1yr },
            { label: '3 Yr', current: hscRates.current_sofr_swap_3yr, prior: hscRates.sofr_swap_3yr },
            { label: '5 Yr', current: hscRates.current_sofr_swap_5yr, prior: hscRates.sofr_swap_5yr },
          ];
          
          let sofr = [
            { label: 'SOFR', current: hscRates.current_sofr_rate, prior: hscRates.sofr_rate },
            { label: 'Prime', current: hscRates.current_prime_rate, prior: hscRates.prime_rate },
            { label: 'Fed Funds', current: hscRates.current_fed_funds_rate, prior: hscRates.fed_funds_rate },
          ];
          
        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                    this.fetch(this.props.location.query);
                }
                return (

            <div className='Stats'>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container'>
                        <div className='page-header'>
                            <div className='page-title'>AthCap Stats</div>
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                <div className='stats-container page-body-container'>
                    <div className='stats-columns'>
                        <div className='stats-column first'>
                        <InfoColumns title={`Closings - ${isYtdClosing ?  'YTD' : ytd - 1}`}
                                         titleRedirect={`/list?source=HSC&hsc_status=Closed&close_of_escrow_min=01%2F01%2F${isYtdClosing ?  ytd : ytd - 1}&close_of_escrow_max=12%2F31%2F${isYtdClosing ?  ytd : ytd - 1}`}
                                         columns={[
                                             {key: 'Transactions', value: stats.closedYtdCount},
                                             {key: 'Total Loan Amount', value: stats.closedYtdLoanAmount},
                                             {key: 'Avg Rate', value: stats.closedYtdAvgrate}
                                         ]}
                            />
                            <div className='line'/>
                            <InfoColumns title={`Loan In Process`}
                                titleRedirect={`/list?source=HSC&hsc_status=Loan In Process`}
                                columns={[
                                    {key: 'Transactions', value: stats.loanInProcessCount},
                                    {key: 'Total Loan Amount', value: stats.loanAmount},
                                    {key: 'Avg Rate', value:stats.loanInProgressAvgrate}
                                ]}
                            />
                            <div className='line'/>
                            <InfoColumns title={`Courting`}
                                titleRedirect={`/list?source=HSC&hsc_status=Courting`}
                                columns={[
                                    {key: 'Transactions', value: stats.courtingTransactions},
                                    {key: 'Total Loan Amount', value: stats.courtingLoanAmount},
                                    {key: 'Avg Rate', value:stats.courtingAvgRate}
                                ]}
                            />
                             <div className='line'/>
                            <InfoColumns title={`Closings - Total`}
                                titleRedirect={`/list?source=HSC&hsc_status=Closed`}
                                columns={[
                                    {key: 'Transactions', value: stats.closedTotalCount},
                                    {key: 'Total Loan Amount', value: stats.closedTotalLoanAmount},
                                    {key: 'Avg Rate', value: stats.closedTotalAvgRate},
                                ]}
                            />
                        </div>
                        <div className='stats-column last'>
                            <HscStatsColumns title={`US Treasuries`}
                                columns={usTreasury}/>
                            <HscStatsColumns title={`1 Mo SOFR Swap`}
                                columns={newOneMonthSOFR}/>
                            <HscStatsColumns title={`Key Rates`}
                                columns={sofr}/>
                        </div>
                    </div>
                </div>
            </div>)
            }}

        </ApolloConsumer>
        )
    }
}